import { AiOutlineArrowRight, AiOutlineEnvironment, AiOutlineMail, AiOutlinePhone, AiOutlineUser } from "react-icons/ai"
import BreadCrumbSection from "../components/breadcrumb_section"
import GoogleMap from "../components/googleMap"
import { BsWhatsapp } from "react-icons/bs";

const ContactAsPage = () =>{

    function OnSubmit(e){
        e.preventDefault();
        // const formData = new FormData(e.target);
        // const data = Object.fromEntries(formData.entries());
        // console.slog(data);  
        e.target.reset()
    }

    return(
        <div className="anu_contact">
            <BreadCrumbSection page="Contact"/>

            <section>
                <div className="container mx-auto">
                    <div className="flex flex-col lg:flex-row justify-center gap-5 mt-10 px-4 lg:px-8 mx-4 lg:mx-24">
                        <div className="block w-full lg:w-1/2">
                            <div className="w-full z-10 relative">
                                <h4 className="lg:text-[24px] xl:text-[24px] md:text-[24px] xl:leading-[60px] lg:leading-[60px] md:leading-[60px] text-[18px] leading-[30px] font-secondary_font font-bold text-[#aa8210]">
                                    Contact Us
                                </h4>
                                <h2 className="lg:text-[50px] xl:text-[50px] md:text-[50px] text-[28px] xl:leading-[60px] lg:leading-[60px] md:leading-[60px] leading-[35px] font-medium">
                                    Every Single Update To Contact Us
                                </h2>
                                <span className="font-secondary_font lg:text-[150px] xl:text-[150px] md:text-[150px] text-[90px] shadow-text-left">
                                    Contact
                                </span>
                            </div>
                            <p className="text-[#757575] pt-10 mb-5">
								We value your relationship and your satisfaction is important to us.
							</p>
                            <ul>
                                <li className="flex items-center py-[35px] border-y-2">
                                    <div className="inline-flex rounded-full bg-[#fec931] p-2 mr-3">
                                        <AiOutlineEnvironment className="text-white text-[30px]"/>
                                    </div>
                                    <div className="font-global_font">
                                        <h2 className="font-medium text-[30px] mt-1">Location</h2>
                                        <address className="not-italic text-[#757575] text-[14px]">
                                            C-12, (KSSIDC), KIADB Industrial Area Nanjungud - 571302
                                        </address>
                                    </div>
                                </li>
                                <li className="flex items-center py-[35px] border-b-2">
                                    <div className="inline-flex rounded-full bg-[#fec931] p-2 mr-3">
                                        <AiOutlineMail className="text-white text-[30px]"/>
                                    </div>
                                    <div className="font-global_font">
                                        <h2 className="font-medium text-[30px] mt-1">Email</h2>
                                        <p className="not-italic text-[#757575] text-[14px]">
                                           anuoffsetprinters2011@gmail.com
                                        </p>
                                    </div>
                                </li>
                                <li className="flex items-center py-[35px] border-b-2">
                                    <div className="inline-flex rounded-full bg-[#209ffa] p-2 mr-3">
                                        <AiOutlinePhone className="text-white text-[30px]"/>
                                    </div>
                                    <div className="font-global_font">
                                        <h2 className="font-medium text-[30px] mt-1">Phone Us</h2>
                                        <p className="not-italic text-[#757575] text-[14px]">
                                           08221-225668, +91 95913 59048 +91 98869 25668
                                        </p>
                                    </div>
                                </li>
                                <li className="flex items-center py-[35px] border-b-2">
                                    <div className="inline-flex rounded-full bg-[#1ac71a] p-3 mr-3">
                                        <BsWhatsapp className="text-white text-[30px]"/>
                                    </div>
                                    <div className="font-global_font">
                                        <h2 className="font-medium text-[30px] mt-1">WhatApp</h2>
                                        <p className="not-italic text-[#757575] text-[14px]">
                                           +91 98869 25668
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className="contact-form w-full lg:w-1/2 mt-10 lg:mt-0">
                            <form onSubmit={(e)=>OnSubmit(e)} method="post" className="font-global_font flex flex-col gap-5">
                                <div>
                                    <span className="text-[#aa8210] text-[16px] font-medium">Full Name</span>
                                    <div className="relative">
                                        <input type="text" placeholder="Enter Your Name" name = "name" required/>
                                        <label className="absolute right-6 top-[35%]">
                                            <AiOutlineUser className="text-[#fec931]"/>
                                        </label>
                                    </div>
                                </div>
                                <div>
                                    <span className="text-[#aa8210] text-[16px] font-medium">Email Address</span>
                                    <div className="relative">
                                        <input type="email" placeholder="Enter Your Email" name = "email" required/>
                                        <label className="absolute right-6 top-[35%]">
                                            <AiOutlineMail className="text-[#fec931]"/>
                                        </label>
                                    </div>
                                </div>
                                <div>
                                    <span className="text-[#aa8210] text-[16px] font-medium">Phone Number</span>
                                    <div className="relative">
                                        <input type="number" placeholder="Enter Your Phone Number" name = "mobile" required/>
                                        <label className="absolute right-6 top-[35%]">
                                            <AiOutlinePhone className="text-[#fec931]"/>
                                        </label>
                                    </div>
                                </div>
                                <div>
                                    <span className="text-[#aa8210] text-[16px] font-medium">Leave A Message  <span className="text-black">(Option)</span></span>
                                    <div className="relative">
                                        <textarea type="text" rows={5} placeholder="Enter Your Message" name = "message" className="min-h-[120px]"/>
                                    </div>
                                </div>
                                <button type="submit" className="uppercase font-global_font font-medium text-white bg-[#aa8210] text-[12px] px-4 py-4 inline-flex items-center gap-2 w-[50%] sm:w-[50%] md:w-[35%]">
                                    Send Message <span className="p-2 bg-white"><AiOutlineArrowRight  className="text-black"/></span>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <GoogleMap/>
        </div>
    )
}

export default ContactAsPage